import React, { useState } from 'react';
import { Box } from '@mui/material';
import { AngularDiProviders } from '../../../../injector/components/angular-di/AngularDiProviders';
import { TargetTypeInfo } from '../../models/target-type-info';
import { WizardStepBaseProps } from '../../../../wizard/interfaces/wizardStep';
import { useWizardStepData } from '../../../../wizard/hooks/useWizardStepData';
import SelectTargetTypeHeader from './SelectTargetTypeHeader';
import SelectTargetTypeList from './SelectTargetTypeList';
import styles from './styles.module.scss';

export function SelectTargetType({
  initialData,
  markDirty,
  onDataChange,
  completeStep
}: WizardStepBaseProps) {
  const [ data, setData ] = useWizardStepData(initialData, onDataChange);

  const onSelect = (targetType: TargetTypeInfo) => {
    if (!data.targetType || data.targetType.type !== targetType.type) {
      markDirty();
    }

    setData((d) => ({
      ...d,
      targetType
    }));

    completeStep();
  };

  return (
    <SelectTargetTypeInner
      onTypeSelect={onSelect}
      defaultSearch={data.targetSearch}
      saveSearch={(value) => {
        setData((d) => ({
          ...d,
          targetSearch: value
        }));
      }}
    />
  );
}

const providers = [];

export default function SelectTargetTypeInner({ onTypeSelect, saveSearch, defaultSearch }) {
  const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(null);

  return (
    <AngularDiProviders providers={providers}>
      <div className={styles.containerSurface} id='scrollable-view' ref={setScrollElement}>
        <div className='body-container'>
          <Box>
            <SelectTargetTypeHeader />

            <SelectTargetTypeList
              onTypeSelect={onTypeSelect}
              saveSearch={saveSearch}
              defaultSearch={defaultSearch}
              scrollElement={scrollElement}
            />
          </Box>
        </div>
      </div>
    </AngularDiProviders>
  );
}
